// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue 			      from 'vue'
import store 		      from '~/store'
import router 		    from '~/router'
import i18n 		      from '~/plugins/i18n'
import VueI18n        from 'vue-i18n'
import App 			      from '~/components/App'
import VueRouter 	    from "vue-router"


import '~/plugins'
import '~/components'
import '%/app.scss'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  i18n,
  store,
  router,
  ...App
})



// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

Vue.use(VueRouter)
Vue.use(require('vue-shortkey'))

// Vue.config.productionTip = false

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js